var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[((_vm.$can( 'admin')))?_c('div',[_c('admin')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }